<template>
	<div class="ml-4">
		<h1 class="text-muted mb-4">
			<vue-fontawesome class="mr-2" size="2" icon="credit-card"></vue-fontawesome>
			Debtors
		</h1>
		<!-- list debtors -->
		<section>
			<div class="d-flex justify-content-between">
				<div>
					<ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
						<li class="nav-item">
							<a class="nav-link active" 
								id="pills-home-tab" 
								data-toggle="pill" 
								href="#pills-home" 
								role="tab" 
								aria-controls="pills-home" 
								aria-selected="true">
								Debtors
							</a>
						</li>
					</ul>
				</div>
			</div>	

			<div class="tab-pane fade show active" 
				id="pills-home" 
				role="tabpanel" 
				aria-labelledby="pills-home-tab">
				<div class="d-flex justify-content-between p-2 mb-5">
					<!-- right -->
					<section class="d-flex">
						<span class="p-2 font-weight-bold" v-if="debtors">
							<span class="text-muted">Found</span> {{debtors.length}}
						</span>
						<div class="dropdown">
							<a class="btn btn-light dropdown-toggle" 
								href="#" role="button" id="dropdownMenuLink" 
								data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
								<vue-fontawesome class="mr-2" icon="filter"></vue-fontawesome> Filters
							</a>
							
							<div class="dropdown-menu border-0 shadow p-3" aria-labelledby="dropdownMenuLink" style="min-width: 25vw">
									<div class="form-group d-flex justify-content-between">
										<label class="p-2">Search</label>
										<input type="text" class="col-8 form-control" v-model="search"> 
									</div>                                     													                                    
									<div class="ml-2 d-flex justify-content-end">
										<button class="btn btn-outline-success"  @click="getDebtors()">
											Get debtors
										</button>
									</div>	
							</div>
						</div>
						<div class="ml-2">
							<button class="btn btn-outline-success border-0"
								@click="$exportTable('expensesTable','debtors.csv')">  
								<vue-fontawesome class="mr-2" icon="file-excel-o"></vue-fontawesome>                              
								Export
							</button>	
						</div>	
					</section>  
					<!-- add buttons -->
					<section>
					<!-- //button area -->
					</section>             																							
				</div>
				<!-- TABLE AND DEPENDENCIES -->
				<div class="rounded shadow border border-light p-2">
					<table class="table table-borderless" id="expensesTable">
						<thead >
							<tr>
								<th scope="col">Customer</th>
								<th scope="col">Amount</th>                               
								<th scope="col"></th>                        
							</tr>
						</thead>                    
						<tbody v-if="debtors && debtors.length">
							<tr v-for="(debtor,index) in debtors" :key="index">
								<td>{{debtor.customer_name}}</td>
								<td>{{debtor.total |intcomma}}</td>                                
								<div class="p-3">
									<a class="dropdown-toggle" href="#" role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
										Actions
									</a>
									<span class="dropdown-menu rounded shadow border-0">                                    																				
										<router-link class="dropdown-item" 
											:to="{ path: `debtor-detail/`, query: { debtor : debtor }}">
											view debtor
										</router-link>
										<span class="d-none dropdown-item">remove</span>										
									</span>
								</div>   
							</tr>
						</tbody>
					</table>
					<div class="p-3 d-flex justify-content-center"
						v-if="debtors && ! debtors.length">
						<span class="p-2">No records to show</span>
					</div>
					<div class="p-3 d-flex justify-content-center"
						v-if="! debtors">
						<div class="spinner-border p-3 m-5" role="status">
							<span class="sr-only">Loading...</span>
						</div>
					</div>	
				</div>            	
			</div>
		</section>
	</div>
</template>
<script>
	export default {
		name: 'debtors',
		props: {
			msg: String
		},
		data(){
			return{
				search:null,
				debtors:null,                                
				//debtor in view
				debtor:null,              
			}
		},
		mounted(){
			this.getDebtors()          
		},
		computed:{     
			account_switched(){
				return this.$store.state.account_switch_count
			}
		},
		watch:{
			account_switched: function(){
				this.getDebtors()
			}, 
			search:function(){			
				this.$searchTable('ordersTable',this.search)			
			}
		},
		methods:{		
			//get_products
			getDebtors: function(){            
				this.debtors = null
				this.$http({
					method:'get',				
					url: this.$API_BASE_URL + `/HJYBCFRB/${this.$version}/debtors/`,
					headers:{
						Authorization: JSON.parse(localStorage.getItem('auth_token'))
					},
					params:{
						date0: this.from_date,
						date1: this.to_date
					},                    
				}).then((response)=>{
					this.debtors = response.data
				}).catch((err)=>{
					this.$emit('alert',err)
				})
			},
			// select debtor to edit or view
			selectDebtor: function(debtor){
				this.debtor = debtor
			},
			}
	}
</script>